// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sbl.sbl--dashboard{padding:2rem 5rem}.sbl.sbl--dashboard .sbl--dashboard--boxes{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:80px}.sbl.sbl--dashboard .sbl--dashboard--boxes,.sbl.sbl--dashboard .sbl--dashboard--navigate--boxes{display:-webkit-box;display:-ms-flexbox;display:flex}.sbl.sbl--dashboard .sbl--dashboard--navigate--boxes>.sbl.sbl--navigate--box:not(:last-child){margin-right:20px}", ""]);
// Exports
module.exports = exports;
